import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getSelectWorkOrderOpOptions } from 'lib/selectors/getSelectWorkOrderOp';
import JobCard from './JobCard';

const WorkOrderOpGroup = ({
  title,
  items,
  nextStep,
  dispatch,
  excludeOperations,
}) => {
  const { isSearchMode } = useSelector(getSelectWorkOrderOpOptions);

  return (
    <>
      {isSearchMode && items?.length > 0 && title}
      {items?.length > 0 &&
        items.map((workOrderOp) => {
          const { workOrder } = workOrderOp;

          const excludeOperation = !!excludeOperations?.find(
            (workOrderOperationRef) => {
              return (
                String(workOrderOp.workOrderOperationRef) ===
                String(workOrderOperationRef)
              );
            }
          );

          return (
            <JobCard
              workOrderOp={workOrderOp}
              exclude={excludeOperation}
              nextStep={nextStep}
              dispatch={dispatch}
              key={`${workOrder?.workOrderId}-${workOrder?.partNumber}-${workOrderOp?.sequenceNumber}`}
            />
          );
        })}
    </>
  );
};

WorkOrderOpGroup.propTypes = {
  title: PropTypes.node,
  items: PropTypes.array,
  nextStep: PropTypes.func,
  dispatch: PropTypes.func,
  excludeOperations: PropTypes.array,
};

export default WorkOrderOpGroup;
